@if (poolCarePage) {
  <!-- <img class="image transparent center cover wave-wrapper" [src]="poolCarePage.hero_image.url"> -->
  <div class="d-lg-none toolbar-break">
  </div>
  <app-image class="hero-img d-none d-lg-block" [prismicImage]="poolCarePage.hero_image" [bcimage]="true"></app-image>
  <div class="container">
    <div class="hero-title my-5">
      <h1>{{poolCarePage.title[0]?.text}}</h1>
    </div>
    <h5>Filter By:</h5>
    <div class="d-flex flex-column flex-md-row mph-select">
      <mat-form-field class="me-3">
        @if (vendorsControl.value?.length < 1) {
          <span class="chip-title">Brands</span>
        }
        <mat-select [formControl]="vendorsControl" [compareWith]="compareVendors" multiple>
          @for (vendor of vendors; track vendor) {
            <mat-option [value]="vendor">{{vendor.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="me-3">
        @if (categoriesControl.value?.length < 1) {
          <span class="chip-title">Categories</span>
        }
        <mat-select [formControl]="categoriesControl" [compareWith]="compareCategories" multiple>
          @for (category of categories; track category) {
            <mat-option [value]="category">{{category.label}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="d-flex justify-content-end me-3">
        @if (vendorsControl.value?.length > 0 || categoriesControl.value?.length > 0) {
          <button class="secondary clear-btn" (click)="clearFilters()">
            Clear Filter
          </button>
        }
      </div>
    </div>
    <div class="d-flex flex-column flex-md-row justify-content-between">
      <div class="mph-select">
        <p>Showing {{filteredProducts.length}} of {{(products$ | async)?.length}} results</p>
        <span class="subtitle me-2">Sort:</span>
        <mat-form-field>
          <mat-select [formControl]="sortControl">
            @for (option of sortOptions; track option) {
              <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    @if ((spinner$ | async)?.show) {
      <div class="spinner">
        <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="medium" color="#000" type="ball-scale-ripple-multiple" [fullScreen]="false"><p style="color: black" > Loading... </p></ngx-spinner>
      </div>
    }
    <div class="row gy-1 gy-lg-5">
      @for (product of filteredProducts; track product) {
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex justify-content-evenly">
          <app-product-card [product]="product"></app-product-card>
        </div>
      }
    </div>
  </div>
}
